import Lenis from '@studio-freight/lenis'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

document.querySelectorAll<HTMLAnchorElement>('a[href^="#"]').forEach((el: Element) => {
  el.addEventListener('click', (e: Event) => {
    e.preventDefault()
    const id: string | undefined = (el as HTMLAnchorElement).getAttribute('href')?.slice(1)
    if (!id) return
    const target: HTMLElement | null = document.getElementById(id)
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' })
    }
  })
})

// Lenis smooth scrolling
let lenis: Lenis

const initSmoothScrolling = (): void => {
  lenis = new Lenis({
    lerp: 0.15
  })

  lenis.on('scroll', () => ScrollTrigger.update())

  const scrollFn = (time: number): void => {
    lenis.raf(time)
    requestAnimationFrame(scrollFn)
  }

  requestAnimationFrame(scrollFn)
}

initSmoothScrolling()
